import { validatePresent } from './validatePresent';

// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-parameters
export const validatePresentWithMessage = <T>(label: string) => {
  return (value: T) => {
    if (validatePresent(value)) {
      return label ? `${label} cannot be blank` : validatePresent(value);
    }

    return null;
  };
};
